const spanishSpeakingAmericanCountries = [
  "Argentina",
  "Bolivia",
  "Chile",
  "Colombia",
  "Costa Rica",
  "Cuba",
  "Ecuador",
  "El Salvador",
  "Guatemala",
  "Honduras",
  "México",
  "Nicaragua",
  "Panamá",
  "Paraguay",
  "Perú",
  "Puerto Rico",
  "República Dominicana",
  "Uruguay",
  "Venezuela",
];

const nameRegex = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ'’ -]+$/;
const vowelRegex = /[aeiouáéíóúüAEIOUÁÉÍÓÚÜ]/;
const uppercaseSequenceRegex = /[A-ZÁÉÍÓÚÜÑ]{8}/;
const phoneRegex = /^\d{7,15}$/;
const nameValidationMessage =
  "Usa de 2 a 50 caracteres, solo letras, espacios, guiones y apóstrofes. Incluye al menos una vocal y evita muchas mayúsculas seguidas.";
const emailValidationMessage = "Ingresa un email válido de hasta 80 caracteres.";
const phoneValidationMessage = "Ingresa solo números, de 7 a 15 dígitos.";

function validateName(value) {
  const trimmedValue = value.trim();

  if (trimmedValue.length < 2 || trimmedValue.length > 50) {
    return nameValidationMessage;
  }

  if (!nameRegex.test(trimmedValue)) {
    return nameValidationMessage;
  }

  if (!vowelRegex.test(trimmedValue)) {
    return nameValidationMessage;
  }

  if (uppercaseSequenceRegex.test(trimmedValue)) {
    return nameValidationMessage;
  }

  return "";
}

function sanitizePhoneValue(value) {
  return value.replace(/\D/g, "").slice(0, 15);
}

function sanitizeNameValue(value) {
  return value.replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ'’ -]/g, "").slice(0, 50);
}

function WebToLeadC() {
  const webToLeadAction = process.env.REACT_APP_WEBTOLEAD_ACTION;
  const webToLeadOid = process.env.REACT_APP_WEBTOLEAD_OID;
  const webToLeadReturnUrl = process.env.REACT_APP_WEBTOLEAD_RET_URL;

  const clearCustomValidity = (event) => {
    event.currentTarget.setCustomValidity("");
  };

  const handlePhoneInput = (event) => {
    const input = event.currentTarget;
    input.value = sanitizePhoneValue(input.value);
    input.setCustomValidity("");
  };

  const handleNameInput = (event) => {
    const input = event.currentTarget;
    input.value = sanitizeNameValue(input.value);
    input.setCustomValidity("");
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    const firstNameInput = form.elements.first_name;
    const lastNameInput = form.elements.last_name;
    const phoneInput = form.elements.phone;
    const emailInput = form.elements.email;

    phoneInput.value = sanitizePhoneValue(phoneInput.value);
    firstNameInput.value = sanitizeNameValue(firstNameInput.value);
    lastNameInput.value = sanitizeNameValue(lastNameInput.value);
    firstNameInput.setCustomValidity(validateName(firstNameInput.value));
    lastNameInput.setCustomValidity(validateName(lastNameInput.value));
    phoneInput.setCustomValidity(
      phoneRegex.test(phoneInput.value) ? "" : phoneValidationMessage
    );
    emailInput.setCustomValidity(
      emailInput.value.length > 80 ? emailValidationMessage : ""
    );

    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      return;
    }

    firstNameInput.value = firstNameInput.value.trim();
    lastNameInput.value = lastNameInput.value.trim();
    emailInput.value = emailInput.value.trim();
  };

  return (
    <div className="contact-container">
      <div className="contact-title">Contact Us</div>

      <form action={webToLeadAction} method="POST" onSubmit={handleSubmit}>
        <input type="hidden" name="oid" value={webToLeadOid} />
        <input type="hidden" name="retURL" value={webToLeadReturnUrl} />

        <div className="form-group">
          <label htmlFor="first_name">First Name</label>
          <input
            id="first_name"
            maxLength="50"
            minLength="2"
            name="first_name"
            onInput={handleNameInput}
            required
            title={nameValidationMessage}
            type="text"
          />
        </div>

        <div className="form-group">
          <label htmlFor="last_name">Last Name</label>
          <input
            id="last_name"
            maxLength="50"
            minLength="2"
            name="last_name"
            onInput={handleNameInput}
            required
            title={nameValidationMessage}
            type="text"
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input
            id="phone"
            inputMode="numeric"
            maxLength="15"
            minLength="7"
            name="phone"
            onInput={handlePhoneInput}
            pattern="[0-9]{7,15}"
            required
            title={phoneValidationMessage}
            type="tel"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            maxLength="80"
            name="email"
            onInput={clearCustomValidity}
            required
            title={emailValidationMessage}
            type="email"
          />
        </div>

        <div className="form-group">
          <label htmlFor="country">País</label>
          <select id="country" name="country" required defaultValue="">
            <option value="" disabled>
              Selecciona tu país
            </option>
            {spanishSpeakingAmericanCountries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <button className="submit-btn" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
}

export default WebToLeadC;
